import { createRootRoute, createRoute } from "@tanstack/react-router";
import { RootLayout } from "./routes/__root";
import { HomePage } from "./routes/index";
import { PlansPage } from "./routes/plans";
import { RecordsPage } from "./routes/records";
import { MethodsPage } from "./routes/methods";
import { AuditPage } from "./routes/audit";
import { DevicesPage } from "./routes/devices";
import { BusinessesPage } from "./routes/businesses";
import { DiscountsPage } from "./routes/discounts";

const rootRoute = createRootRoute({ component: RootLayout });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

const plansRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/plans",
  component: PlansPage,
});

const recordsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/records",
  component: RecordsPage,
});

const methodsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/methods",
  component: MethodsPage,
});

const auditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/audit",
  component: AuditPage,
});

const devicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/devices",
  component: DevicesPage,
});

const businessesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/businesses",
  component: BusinessesPage,
});

const discountsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/discounts",
  component: DiscountsPage,
});

export const routeTree = rootRoute.addChildren([indexRoute, plansRoute, recordsRoute, methodsRoute, auditRoute, devicesRoute, businessesRoute, discountsRoute]);
